import { bodyUtils, formUtils, postLoadUtils, scrollTriggers, windowScrollUtils } from './js/body';

/**
 *
 */
$(function() {
  bodyUtils();
  formUtils();
  postLoadUtils();
  scrollTriggers();
});

/**
 *
 */
$(window).on('load', function() {
  windowScrollUtils();
});

/**
 *
 */
$(window).on('scroll', function() {
  windowScrollUtils();
});

/**
 *
 */
$(window).on('resize', function() {

});
